// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CUu2D","label":"styles_label__eII0h"};